<template>
    <div class="Moments_container">
        <template v-if="!loadMore">
            <div class="tab" :class="{'shadow': isFixed}" :style="{top: tabFixedTop + 'px'}">
                <div class="tab_fixed">
                    <ul>
                        <li v-for="(item,index) in tabs" :key="index"
                            :class="{'active': item.type == type}"
                            @click="selectTab(item.type)"
                        >{{item.name}}</li>
                    </ul>
                </div>
            </div>
            <div class="list">
                <ul v-if="typeList.length">
                    <template  v-for="(item,index) in typeList">
                        <li :key="index"  @click="goDetail(index,item.url)">
                            <div class="article_title">{{item.title}}</div>
                            <template v-if="item.type == '图片'">
                                <div class="img_content style_1" v-if="item.imgCount == 1">
                                    <img :src="cmsIsDomain(item.first3Imgs[0])">
                                </div>
                                <div class="img_content style_2" v-else-if="item.imgCount == 2">
                                    <div><img :src="cmsIsDomain(item.first3Imgs[0])"></div>
                                    <div><img :src="cmsIsDomain(item.first3Imgs[1])"></div>
                                </div>
                                <div class="img_content style_3" v-else-if="item.imgCount >= 3">
                                    <div><img :src="cmsIsDomain(item.first3Imgs[0])"></div>
                                    <div>
                                        <div><img :src="cmsIsDomain(item.first3Imgs[1])"></div>
                                        <div>
                                            <template v-if="item.imgCount > 3">
                                                <img :src="cmsIsDomain(item.first3Imgs[2])">
                                                <div class="masking">+{{item.imgCount - 3}}</div>
                                            </template>
                                            <template v-else>
                                                <img :src="cmsIsDomain(item.first3Imgs[2])">
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="item.type == '视频'">
                                <div class="video_content">
                                    <video 
                                        :data-index="index"
                                        :src="cmsIsDomain(item.videoUrl)" 
                                        width="100%"
                                        controls 
                                        controlsList="nodownload" 
                                        x5-video-player-type='h5' x5-video-player-fullscreen='true' playsinline webkit-playsinline 
                                        preload
                                        @pause="videoPause($event)"
                                        @ended="videoPause($event)"
                                        @error="videoPause($event)"
                                        @click.stop
                                        v-show="videoActiveIndex == index"
                                    >
                                        视频加载失败
                                    </video>
                                    <img class="head_url" :src="cmsIsDomain(item.videoHeadUrl)" v-show="videoActiveIndex != index" @error="e=>e.target.src = require('@images/news/cover@2x.png')">
                                    <YD-image class="icon" src="icon/icon_video_play" @click.native.stop="videoPlay(index)" v-show="videoActiveIndex != index"></YD-image>
                                </div>
                            </template>
                            <div class="release_info">
                                <div class="publisher">{{item.author}}</div>
                                <div class="release_time">{{item.addDate | dateFormat('yyyy年M月d日发布')}}</div>
                            </div>
                        </li>
                    </template>
                </ul>
                <template v-else>
                    <Text-prompt :showImg="true" noDataImg="no_data/暂无内容@2x.png"></Text-prompt>
                </template>  
            </div>
        </template>
        <template v-else>
            <Text-prompt :text="loadMore" noDataImg="no_data/暂无内容@2x.png"></Text-prompt>
        </template>      
    </div>
</template>
<script>
import tools from '@/common/tools.js';
import appInteraction from '@/common/appInteraction.js';
export default {
    props:{
        isCurrentShow:{
            type: Boolean,
            default: false
        },
        channelUrl:{
            type: String,
            default: ''
        },
        isFixed:{
            type: Boolean,
            default: false
        },
        isSynthesis: {
            type: Boolean,
            default: false
        },
        events: Object
    },
    data(){
        return {
            tabs:[{
                type: 0,
                name: '全部'
            },{
                type: 1,
                name: '图片'
            },{
                type: 2,
                name: '视频'
            }],
            type: 0,
            channelList: [],
            loadMore: "加载中...",
            playVideoDom: null,
            videoActiveIndex: -1
        }
    },
    created(){
        if(this.isSynthesis){
            this.getEventsNewsList();
        }else{
            this.getNewsList();
        }
    },
    watch:{
        isCurrentShow(newVal){
            if(!newVal){
                if(this.playVideoDom){
                    this.playVideoDom.pause();
                }
            }
        },
        events: {
            deep: true,
            handler(){
                this.getEventsNewsList();
            }
        }
    },
    computed:{
        fixedTop(){
            return tools.remToPx(422 - 88);
        },
        tabFixedTop(){
            return tools.remToPx(168) + (this.isSynthesis ? tools.remToPx(80) : 0);
        },
        typeList(){
            let list = this.channelList;
            if(this.type == 1){
                return list.filter(item => item.type == '图片');
            }else if(this.type == 2){
                return list.filter(item => item.type == '视频');
            }
            return list; 
        }
    },
    methods:{
        setScrollTop(){
			if(this.isFixed){
                this.$parent.scrollTo({
                    scrollTop: this.fixedTop + 1,
                    behavior: 'instant'
                })
            }
        },
        getNewsList(){
            if(this.channelUrl){
                this.$api.json(this.channelUrl).then(data => {
                    this.channelList = data.contents || [];
                    this.loadMore = this.channelList.length > 0 ? "" : "无数据";
                }).catch(()=>{
                    this.loadMore = "数据加载失败";
                });
            } else {
                this.loadMore = "无数据";
            }
        },
        getEventsNewsList(){
            this.channelList = [];
            this.channelListLoadMore = '加载中...';
            if(this.events){
                let {
                    MatchPicsChanId
                } = this.events;
                if(MatchPicsChanId){
                    this.$api.json(MatchPicsChanId).then(data => {
                        this.channelList = data.contents || [];
                        this.loadMore = this.channelList.length > 0 ? "" : "无数据";
                    }).catch(()=>{
                        this.loadMore = "数据加载失败";
                    });
                }else{
                    this.loadMore = "无数据";
                }
            }
        },
        selectTab(type){
            if(this.type != type){
                this.currentVideoId = null;
                this.$nextTick(function() {
                    this.type = type;
                    this.setScrollTop();
                });
            }
        },
        goDetail(index, url){
            if(this.playVideoDom){
                this.playVideoDom.pause();
            }
            let videoDom = this.$el.querySelector(`video[data-index="${index}"]`);
            if(videoDom){
                let currentTime = videoDom.currentTime;
                if(currentTime > 0){
                    url = url + (url.indexOf('?') > -1 ? '&' : '?') + `progress=${currentTime}`;
                }
            }
            url = this.cmsIsDomain(url);
            appInteraction.webviewOpenUrl(url);
        },
        videoPlay(index){
            let target = this.$el.querySelector(`video[data-index="${index}"]`);
            if(this.playVideoDom && this.playVideoDom.getAttribute('data-index') != target.getAttribute('data-index')){
                this.playVideoDom.pause();
            }
            target.play();
            this.playVideoDom = target;
            this.videoActiveIndex = index;
        },
        videoPause({target}){
            if(this.playVideoDom && this.playVideoDom.getAttribute('data-index') == target.getAttribute('data-index')){
                this.playVideoDom = null;
            }
            this.videoActiveIndex = -1;
        },
        cmsIsDomain(url){
            if(!(/^http|https/.test(url))){
                url = process.env.VUE_APP_CMS_URL + url;
            }
            return url;
        }
    }
}
</script>
<style lang="scss" scoped>
.Moments_container{
    .tab{
        width: 100%;
        height: 80px;
            background: #FFFFFF;
        position: sticky;
        left: 0;
        z-index: 2;
        &.shadow{
            @include tab-shadow;
        }
        .tab_fixed{
            width: 100%;
            height: 80px;
            ul{
                width: 100%;
                height: 80px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                li{
                    flex: 1;
                    font-size: 28px;
                    color: #666666;
                    font-weight: 400;
                    text-align: center;
                    &.active{
                        color: #7AD21A;
                        font-weight: 500;
                    }
                }
            }
        }
    }
    .list{
        width: 100%;
        height: auto;
        padding: 40px 0 40px 40px;
        box-sizing: border-box;
        ul li{
            width: 100%;
            height: auto;
            padding-right: 40px;
            padding-bottom: 32px;
            box-sizing: border-box;
            border-bottom: 1px #F0F0F0 solid;
            margin-bottom: 33px;
            &:last-of-type{
                margin-bottom: 0;
                border: none;
            }
            .article_title{
                font-size: 32px;
                color: #1B1C1E;
                font-weight: 500;
                line-height: 44px;
                margin-bottom: 24px;
            }
            .img_content{
                width: 100%;
                height: auto;
                margin-bottom: 16px;
                border-radius: 10px;
                overflow: hidden;
                &.style_1{
                    height: 476.27px;
                }
                &.style_2{
                    height: 236px;
                    display: flex;
                    justify-content: space-between;
                    >div{
                        width: 332px;
                        height: 100%;
                    }
                }
                &.style_3{
                    height: 316px;
                    display: flex;
                    justify-content: space-between;
                    >div{
                        height: 100%;
                        &:nth-of-type(1){
                            width: 444px;
                        }
                        &:nth-of-type(2){
                            width: 220px;
                            >div{
                                width: 100%;
                                height: 156px;
                                margin-bottom: 4px;
                                &:last-of-type{
                                    margin-bottom: 0;
                                }
                                position: relative;
                                .masking{
                                    width: 100%;
                                    height: 100%;
                                    background: rgba(0,0,0,0.60);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    font-size: 44px;
                                    color: #FFFFFF;
                                    font-weight: 500;
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                }
                            }
                        }
                    }
                }
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .video_content{
                width: 100%;
                height: 376px;
                border-radius: 10px;
                overflow: hidden;
                margin-bottom: 16px;
                position: relative;
                background: #1B1C1E;
                .head_url{
                    width: 100%;
                    height: 100%;
                    border-radius: 10px;
                    object-fit: cover;
                }
                .icon{
                    width: 88px;
                    height: 88px;
                    position: absolute;
                    top: calc(50% - 44px);
                    left: calc(50% - 44px);
                }
                video{
                    height: 100%;
                    width: 100%;
                    display: block;
                }
            }
            .release_info{
                display: flex;
                justify-content: space-between;
                line-height: 34px;
                font-size: 24px;
                .publisher{
                    color: #41454D;
                    font-weight: 400;
                }
                .release_time{
                    color: #999999;
                    font-weight: 400;
                }
            }
        }
    }
}
</style>